import React from 'react';
import { Outlet } from 'react-router-dom';
// import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';
import './UserLayout.css';
import FullScreenNavbar from '../FullScreenNavbar/FullScreenNavbar';

const UserLayout = () => {
  return (
    <div className="app-layout">
      <FullScreenNavbar/>
      <main className="main-content">
        <Outlet />
      </main>
      <Footer/>
    </div>
  );
};

export default UserLayout;
